import { useEffect } from 'react';

function useStatistic(key:string = 'taobaoke-center-b') {
  useEffect(() => {
    //@ts-ignore
    const kaq = window.kaq
    kaq('create', key)
    kaq('set', 'pageType', 100)
    kaq('send', 'pageview')
  }, [])
}

export default useStatistic;

export function useClickStatistic(traceId: string, compName: string) {
  // @ts-ignore
  const kaq = window.kaq;
  kaq('create', traceId);
  kaq('send', 'event', compName, 'click');
}

